__turbopack_context__.v({
  "availability_container": "styles-module-scss-module__AJicCW__availability_container",
  "button_container": "styles-module-scss-module__AJicCW__button_container",
  "checkboxes_container": "styles-module-scss-module__AJicCW__checkboxes_container",
  "confirm_container": "styles-module-scss-module__AJicCW__confirm_container",
  "date_container": "styles-module-scss-module__AJicCW__date_container",
  "details_container": "styles-module-scss-module__AJicCW__details_container",
  "disclaimer": "styles-module-scss-module__AJicCW__disclaimer",
  "error_message": "styles-module-scss-module__AJicCW__error_message",
  "header": "styles-module-scss-module__AJicCW__header",
  "information_container": "styles-module-scss-module__AJicCW__information_container",
  "time_container": "styles-module-scss-module__AJicCW__time_container",
});
